import moment from 'moment';

export const getTodayRange = () => {
  return [moment().utc(), moment().utc()];
};

export const getThisWeek = () => {
  // Use ISO week to set Monday as the first day of the week
  return [moment().utc().startOf('isoWeek'), moment().utc().endOf('isoWeek')];
};

export const getLastSevenDays = () => {
  return [moment().utc().subtract(7, 'days'), moment().utc()];
};

export const getThisMonth = () => {
  return [moment().utc().startOf('month'), moment().utc().endOf('month')];
};

export const getLastThirtyDays = () => {
  return [moment().utc().subtract(30, 'days'), moment().utc()];
};

export const getLastMonth = () => {
  return [moment().utc().subtract(1, 'months').startOf('month'), moment().utc().subtract(1, 'months').endOf('month')];
};
